import actionTypes from '../actionTypes';

const initialState = {
    email: '',
    code: '',
    error: undefined
};


const main = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_EMAIL:
            return {...state, email: action.payload, error: undefined};
        case actionTypes.SET_CODE:
            return {...state, code: action.payload, error: undefined};
        case actionTypes.SEND_ERROR:
            return {...state, error: action.payload};
        case actionTypes.LOGOUT:
            return {...initialState}
        default:
            return state;
    }
};

export default main;
